import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const LazyLoad = ({ children, offset = 0, once = false, className }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          if (once) observer.disconnect();
        } else if (!once) {
          setVisible(false);
        }
      },
      { rootMargin: `${offset}px` }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [offset, once]);

  return (
    <div ref={ref} className={className}>
      {visible ? children : null}
    </div>
  );
};

LazyLoad.propTypes = {
  children: PropTypes.node,
  offset: PropTypes.number,
  once: PropTypes.bool,
  className: PropTypes.string
};

export default LazyLoad;
